import React from 'react'
import { useIsOnline } from 'commons/useIsOnline'
import NetworkError from 'app/components/NetworkError'

import { UsageHistoryV4 } from './V4/UsageHistoryV4'

const UsageHistory = () => {
  const [isOnline] = useIsOnline()

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => {}} />
  }

  return <UsageHistoryV4 />
}

export default UsageHistory
